import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { getFormattedDateTime } from 'ecs-react-components/dist/index.es';

import NewQuestionnaireButton from './NewQuestionnaireButton';
import { messages } from './Questionnaires.i18n';

export class QuestionnaireCard extends React.Component {
  renderDate(date) {
    const dateClass = moment(date).isSameOrAfter(moment(), 'day') ? 'date' : 'date overdue';
    const buttonText = moment(date).isSameOrAfter(moment(), 'day')
      ? <FormattedMessage { ...messages.date.due } />
      : <FormattedMessage { ...messages.date.overdue } />;
    const formattedDate = getFormattedDateTime(date, date, this.props.language);
    return (<span className={dateClass}>{buttonText} {formattedDate.datePart}</span>);
  }

  render() {
    const indicatorCss = 'fa fa-circle' + (this.props.item.dueDate !== null ? '' : ' hidden');
    const colClass = this.props.colCssClass || 'col-md-6 col-sm-12';
    return (
      <div key={ this.props.item.assignedQuestionnaireId }>
        <div className="row">
          <div className={colClass}>
            <div data-qa-item={ this.props.item.assignedQuestionnaireId }
              className="panel panel-default description-box notheme"
            >
              <div className="panel-body">
                  <NewQuestionnaireButton
                    assignedQuestionnaireId={ this.props.item.assignedQuestionnaireId }
                    hideDecline={this.props.hideDecline}
                  />
                  <p>
                    <span className={ indicatorCss }></span>
                    <span className="title">{this.props.item.templateTitle}</span>
                    <br />
                    {this.renderDate(this.props.item.dueDate)}
                    <br /><br />
                    {this.props.item.templateDescription}
                  </p>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer tiny" />
        <div className="spacer small" />
      </div>
    );
  }
}

QuestionnaireCard.propTypes = {
  item: PropTypes.object,
  language: PropTypes.string,
  hideDecline: PropTypes.bool,
  colCssClass: PropTypes.string,
};